import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import WishlistMain from "./WishlistMain";
import Footer from "../../components/Footer";

const Wishlist = () => {
  return (
    <>
      <HeaderFour />

      <WishlistMain />

      <Footer />
    </>
  );
};

export default Wishlist;
